export const searchResults = [
  {
    primary: 'Usability fixes',
    href: '/BUG-90001',
    secondary: ['BUG-90001', 'Updated on Thursday'],
    id: 'BUG-90001'
  },
  {
    primary: 'RTE Enhancements',
    href: '/STORY-92120',
    secondary: ['STORY-92120', 'Updated on Monday'],
    id: 'STORY-92120'
  },
  {
    primary: 'Cosmos Svelte Components',
    href: '/EPIC-84623',
    secondary: ['EPIC-84623', 'Updated on Tuesday'],
    id: 'EPIC-84623'
  }
];

export const recentSearches = [
  { id: '1', primary: 'How to pet a dog', href: '/search?query=how%20to%20pet%20a%20dog' },
  { id: '2', primary: 'Can dogs smile', href: '/search?query=can%dogs%smile' }
];
